$(document).foundation();

function loadMapScript(mapFunc) {
	var script = document.createElement('script');
	script.type = 'text/javascript';
	script.src = 'https://maps.googleapis.com/maps/api/js?&key=AIzaSyCso0W9mrJF-FLYkcOEw-3URP31Phai9Pw&libraries=places&' +
	  'callback='+mapFunc;
	document.body.appendChild(script);
}

function loadDeploymentMap() {
    DeploymentMap.init();
}

$(function() {

    $(document).on('click', '.icon-menu', function() {
        $(this).toggleClass('open');
        $('#header').toggleClass('menu-open');
        $('.mobile-menu').toggleClass('open');

        // $('#dropdown-menu').toggleClass('open');
        // $('#header').toggleClass('menu-open');
        // $('body').toggleClass('menu-open');
        // if ($(this).hasClass('open')) {
        //     $('#nav-shade').fadeIn(300);
        // } else {
        //     $('#nav-shade').fadeOut(300);
        // }
    });

    $('.latest-news').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:false,
        dots: false,
        arrows: true
    });

    if ($('.rellax').length > 0) {
    	// requestAnimationFrame(() => {
	        var rellax = new Rellax('.rellax', {
        	    center:true
        	});
    	// });
    }

    $(document).on('click', '.sub-menu-icon', function() {
        var menuItem = $(this).parent('.l1-item');
        menuItem.toggleClass('expanded');
    });

    $(document).on('click', '.btn-close-alert', function() {
        $(this).parent('.alert-bar').remove();
    });

    $('.parent').mouseenter(function() {
        var navTray = $(this).find('.tray');
        navTray.fadeIn(400);
    }).mouseleave(function(event) {
        var navTray = $(this).find('.tray');
        navTray.fadeOut(250);
    });

    if ($('#social-slick').length > 0) {
        $('#social-slick').slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            arrows: false,
            responsive: [
              {
                breakpoint: 750,
                settings: {
                    dots: true,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
              },
            ]
        });
    }

    if ($('.slider-element-slick').length > 0) {
        $('.slider-element-slick').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed:10000,
            speed: 600,
            dots: true,
            appendDots: $('.slider-element-wrap'),
            appendArrows: $('.slider-element-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></i></a>',
            responsive: [
              {
                breakpoint: 1000,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.image-carousel').length > 0) {
        $('.image-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:true,
            speed: 600,
            dots: false,
            appendArrows: $('.image-carousel-wrap'),
            prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
            nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
            responsive: [
              {
                breakpoint: 500,
                settings: {
                    arrows: false
                }
              },
            ]
        });
    }

    if ($('.stacked-image-carousel').length > 0) {
        $('.stacked-image-carousel').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay:false,
            speed: 600,
            dots: false,
            appendArrows: $('.stacked-image-carousel-wrap'),
            prevArrow:'<a class="slider-prev"></a>',
            nextArrow:'<a class="slider-next"></a>',
            // responsive: [
            //   {
            //     breakpoint: 500,
            //     settings: {
            //         arrows: false
            //     }
            //   },
            // ]
        });
    }

    if ($('.tile-slider').length > 0) {
        $(".tile-slider").each(function(index, element) {
            $(this).slick({
                infinite: true,
                slidesToShow: $(this).data("count"),
                slidesToScroll: 1,
                autoplay:true,
                speed: 600,
                dots: false,
                appendArrows: $('.tile-grid-wrap'),
                prevArrow:'<a class="slider-prev"><i class="fal fa-chevron-left"></i></a>',
                nextArrow:'<a class="slider-next"><i class="fal fa-chevron-right"></i></a>',
                responsive: [
                  {
                    breakpoint: 500,
                    settings: {
                        arrows: false
                    }
                  },
                ]
            });
       });
    }

    if ($('.staggered-item-slider').length > 0) {
        $(".staggered-item-slider").each(function(index, element) {
            $(this).slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay:false,
                speed: 600,
                dots: false,
                appendArrows: $('.staggered-item-wrap'),
                prevArrow:'<a class="slider-prev"></a>',
                nextArrow:'<a class="slider-next"></a>',
            });
       });
    }
    //---------------------------------------------------------



    $('#contact-form').submit(function() {
        // var submitMessage = $(this).parent().find('.submit-message');
        $('#contact-form').addClass('loading');

        $(this).ajaxSubmit({
            success: function(){
                $('#contact-submit-modal').foundation('open');
                // setTimeout(function() {
                //     $('#contact-submit-modal').foundation('close');
                // },5000);
                // submitMessage.removeClass('hide');
                $('#contact-form').removeClass('loading');
            },
            clearForm:true
        });

        return false;
    });

    $('#OtherReferralSource_Holder').hide();
    $('#OtherReferralSource').hide();
    $(document).on('change', '#Referral', function() {
        if ($(this).val() == 'Other') {
            $('#OtherReferralSource_Holder').show();
            $('#OtherReferralSource').show().attr('required','required');
        } else {
            $('#OtherReferralSource_Holder').hide();
            $('#OtherReferralSource').val('').removeAttr('required');
        }
    });

    $('#Form_ApplicationForm').submit(function() {
        // var submitMessage = $(this).parent().find('.submit-message');
        $('#Form_ApplicationForm').addClass('loading');

        $(this).ajaxSubmit({
            success: function(){
                $('#form-success-reveal').foundation('open');
                // setTimeout(function() {
                //     $('#form-success-reveal').foundation('close');
                // },5000);
                // submitMessage.removeClass('hide');
            },
            clearForm:true
        });

        return false;
    });

    $('[data-reveal]').on('open.zf.trigger', function(){
        var reveal = $(this);
        var embedContent = reveal.find('iframe');
        if (embedContent.length) {
            if (embedContent.attr('src').includes('vimeo')) {
                var player = new Vimeo.Player(embedContent[0]);
                player.play().then(function() {
                    console.log('played it');
                }).catch(function(error) {
                    switch (error.name) {
                        case 'PasswordError':
                            // the video is password-protected and the viewer needs to enter the
                            // password first
                            break;

                        case 'PrivacyError':
                            // the video is private
                            break;

                        default:
                            // some other error occurred
                            break;
                    }
                });
            }
        }
    });
    $('[data-reveal]').on('close.zf.trigger', function(){
        var reveal = $(this);
        var embedContent = reveal.find('iframe');
        if (embedContent.length) {
            if (embedContent.attr('src').includes('vimeo')) {
                var player = new Vimeo.Player(embedContent[0]);
                player.pause().then(function() {
                }).catch(function(error) {
                    switch (error.name) {
                        case 'PasswordError':
                            console.log('vimeo error')
                        break;

                        case 'PrivacyError':
                            console.log('vimeo error')
                            break;

                        default:
                            console.log('vimeo error')
                            break;
                    }
                });
            }
        }
    });

    // Newsletter controls
    $(document).on("submit", "form.newsletter", event => {
        event.preventDefault();

        fetch("/home/subscribe", {
            method: "POST",
            body: new FormData(event.target)
        })
        .then(res => res.json())
        .then(({ success, message }) => {
            if (success) {
                event.target.setAttribute("complete", message);
            }
            else {
                alert(message);
            }
        });

        return false;
    });

    // Load more blog posts
    $(document).on("click", ".Blog .load-more", () => {
        let count = $(".Blog .posts .post").length;
        let link = $(".Blog .posts").data("link");
        let category = $(".Blog .posts").data("category") || 0;

        fetch(`${link}load_more?offset=${count}&category=${category}`)
        .then(res => res.json())
        .then(posts => {
            for (let post of posts) $(".Blog .posts").append($(post));

            $(".Blog .load-more").toggleClass("inactive", parseInt($(".Blog .posts").data("total-posts")) - $(".Blog .posts .post").length <= 0);
        });
    });

    // FAQS expand collapse
    $(document).on('click', '.faq-expand', function() {
        $(this).parent().toggleClass('open');
    });

    // Down arrow button - scrolls down to next page section
    $(document).on('click', '.btn-scroll-down', function() {
        var parent = $(this).parent();
        var nextSectionTop = parent.offset().top + parent.outerHeight();
        console.log(nextSectionTop);
        $("html, body").animate({ scrollTop: nextSectionTop }, 1200);
        return false;
    });

    // Careers
    $('#career-category-select').on('change', function() {
        var page = $(this).data('page-slug')
        var cat = $(this).val();

        window.location = '/' + page + '/' + cat + '#opportunities';
    });

    $(document).on('click', '.career-option', function() {
        var option = $(this).data('option');
        $('.career-option').removeClass('active');
        $(this).addClass('active');
        $('.career-grid').addClass('hide');
        $('#career-grid-'+option).removeClass('hide');

        // $('.career-option').removeClass('active');
        // $(this).addClass('active');
        // if (option == '*') {
        //     $('.career-cell').removeClass('hide').addClass('show');
        // } else {
        //     $('.career-cell').addClass('hide').removeClass('show');
        //     $('.career-cell[data-option="'+option+'"]').removeClass('hide').addClass('show');
        // }
    });

    $('.career-event-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay:false,
        dots: true,
        arrows: true

    });

    // ------------------------------------

    if ($('#map-canvas').length) {
        console.log('found map');
        loadMapScript('loadDeploymentMap');
    }

    $(document).on('click', '#btn-volunteer-scroll', function() {
        var section = $('#volunteer-section')
        var nextSectionTop = section.offset().top;
        $("html, body").animate({ scrollTop: nextSectionTop });
        return false;
    });

    $(document).on('click', '.btn-play-embed', function() {
        var id = $(this).data('modal');
        var reveal = $('#video-embed-reveal-'+id);
        reveal.foundation('open');
        var embedContent = reveal.find('iframe');
        if (embedContent.length) {
            if (embedContent.attr('src').includes('vimeo')) {
                var player = new Vimeo.Player(embedContent[0]);
                player.play();
            }
        }
        return false;
    });

    $(document).on('click', '.link-share', function() {
        let data = $(this).data();
        if (navigator.share) {
            const sharePromise = navigator.share(data);
        } else {
            // var pos = $(this).position();
            // console.log(pos);
            // $('.share-popup').offset({left:pos.left,top:pos.top});
            $('.share-popup').show();
        }
    });
    $(document).on('click', '.share-link', function() {
        let popup = $(this).parents('.share-popup');
        let text = popup.data('text');
        let platform = $(this).data('platform');
        let link = window.location.href;
        switch (platform) {
            case 'fb':
                ShareToFaceBook(link);
                break;
            case 'tw':
                ShareToTwitter(link, text);
                break;
            case 'li':
                ShareToLinkedIn(link, text);
                break;
            case 'cp':
                fallbackCopyTextToClipboard(link);
                $('.copy-success').fadeIn();
                setTimeout(() => {$('.copy-success').fadeOut();},2500);
                break;

            default:
        }
    });

    $(document).on('click', '.link-share-close', function() {
        $('.share-popup').hide();
    });

    // set animation timing
    var animationDelay = 3500,
        // loading bar effect
        barAnimationDelay = 3800,
        barWaiting = barAnimationDelay - 3000, // 3s is the duration of the transition on the loading bar - set in CSS
        // letters effect
        lettersDelay = 50;

    initHeadline();

    function initHeadline() {
      // insert <i> element for each letter of a changing word
      singleLetters($('.cd-headline.letters').find('b'));
      // initialise headline animation
      animateHeadline($('.cd-headline'));
    }

    function singleLetters($words) {
      $words.each(function() {
        var word = $(this),
            letters = word.text().split(''),
            selected = word.hasClass('is-visible');
        for (i in letters) {
          if(word.parents('.rotate-2').length > 0) letters[i] = '<em>' + letters[i] + '</em>';
          letters[i] = (selected) ? '<i class="in">' + letters[i] + '</i>': '<i>' + letters[i] + '</i>';
        }
        var newLetters = letters.join('');
        word.html(newLetters);
      });
    }

    function animateHeadline($headlines) {
      var duration = animationDelay;
      $headlines.each(function() {
        var headline = $(this);
        var spanWrapper = headline.find('.cd-words-wrapper'),
            newWidth = spanWrapper.width() + 5;
        spanWrapper.css('width', newWidth);
        if(headline.hasClass('loading-bar')) {
          duration = barAnimationDelay;
          spanWrapper.css('width', '');
          setTimeout(function(){ spanWrapper.addClass('is-loading') }, barWaiting);
        };
        //trigger animation
        setTimeout(function(){ hideWord( headline.find('.is-visible').eq(0) ) }, duration);
      });
    }

    function hideWord($word) {
      var nextWord = takeNext($word);
      if($word.parents('.cd-headline').hasClass('letters')) {
        var bool = ($word.children('i').length >= nextWord.children('i').length) ? true : false;
        hideLetter($word.find('i').eq(0), $word, bool, lettersDelay);
        showLetter(nextWord.find('i').eq(0), nextWord, bool, lettersDelay);
      } else if ($word.parents('.cd-headline').hasClass('loading-bar')) {
        $word.parents('.cd-words-wrapper').removeClass('is-loading');
        switchWord($word, nextWord);
        setTimeout(function(){ hideWord(nextWord) }, barAnimationDelay);
        setTimeout(function(){ $word.parents('.cd-words-wrapper').addClass('is-loading') }, barWaiting);
      } else {
        switchWord($word, nextWord);
        setTimeout(function(){ hideWord(nextWord) }, animationDelay);
      }
    }

    function hideLetter($letter, $word, $bool, $duration) {
      $letter.removeClass('in').addClass('out');
      if(!$letter.is(':last-child')) {
        setTimeout(function(){ hideLetter($letter.next(), $word, $bool, $duration); }, $duration);
      } else if($bool) {
        setTimeout(function(){ hideWord(takeNext($word)) }, animationDelay);
      }
      if($letter.is(':last-child') && $('html').hasClass('no-csstransitions')) {
        var nextWord = takeNext($word);
        switchWord($word, nextWord);
      }
    }

    function showLetter($letter, $word, $bool, $duration) {
      $letter.addClass('in').removeClass('out');
      if(!$letter.is(':last-child')) {
        setTimeout(function(){ showLetter($letter.next(), $word, $bool, $duration); }, $duration);
      } else {
        if(!$bool) { setTimeout(function(){ hideWord($word) }, animationDelay) }
      }
    }

    function takeNext($word) {
      return (!$word.is(':last-child')) ? $word.next() : $word.parent().children().eq(0);
    }

    function takePrev($word) {
      return (!$word.is(':first-child')) ? $word.prev() : $word.parent().children().last();
    }

    function switchWord($oldWord, $newWord) {
      $oldWord.removeClass('is-visible').addClass('is-hidden');
      $newWord.removeClass('is-hidden').addClass('is-visible');
    }

    function ShareToFaceBook(url) {
        let params = "menubar=no,toolbar=no,status=no,width=570,height=570";
        let shareUrl = `http://www.facebook.com/sharer/sharer.phpu=${url}`;
        window.open(shareUrl,"NewWindow" , params);
    }

    function ShareToTwitter(link, text){
        let url = encodeURIComponent(link);
        let params = "menubar=no,toolbar=no,status=no,width=570,height=570";
        let Shareurl = 'https://twitter.com/intent/tweet?url='+url+'&text='+text;
        window.open(Shareurl, "NewWindow", params);
    }

    function ShareToLinkedIn(link, text) {
        let url = encodeURIComponent(link);
        let params = "menubar=no,toolbar=no,status=no,width=570,height=570";
        let Shareurl = 'https://www.linkedin.com/shareArticle?mini=true&url='+link+'&title='+text+'&summary='+text+'&source=Upskill%20NWA';
        window.open(Shareurl, "NewWindow", params);
    }

    function fallbackCopyTextToClipboard(text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    }
});
